import { render, staticRenderFns } from "./NewsFilter.vue?vue&type=template&id=72bc80ff&scoped=true&"
import script from "./NewsFilter.vue?vue&type=script&lang=js&"
export * from "./NewsFilter.vue?vue&type=script&lang=js&"
import style0 from "./NewsFilter.vue?vue&type=style&index=0&id=72bc80ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bc80ff",
  null
  
)

export default component.exports